import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { Globe, Package, Smartphone } from 'lucide-react';
import { AccessoriesView } from './AccessoriesView';
import { DeviceModelsView } from './DeviceModelsView';
import { TravelEsimTariffsView } from './TravelEsimTariffsView';

export function CatalogManagementView() {
  return (
    <div className="space-y-8">
      <div>
        <h1 className="text-2xl font-bold text-slate-900">
          Gestion du Catalogue
        </h1>
        <p className="text-sm text-slate-500 mt-1">
          Gérez les modèles d'appareils, leurs déclinaisons, les accessoires et
          la grille des eSIM internationales
        </p>
      </div>

      <Tabs defaultValue="models" className="space-y-6">
        <TabsList className="bg-white shadow-sm rounded-xl h-12 p-1 w-full sm:w-auto">
          <TabsTrigger
            value="models"
            className="cursor-pointer rounded-lg px-4 py-2 text-sm font-medium data-[state=active]:bg-emerald-50 data-[state=active]:text-emerald-700 data-[state=active]:shadow-none gap-2"
          >
            <Smartphone className="h-4 w-4" />
            Modèles d'appareils
          </TabsTrigger>
          <TabsTrigger
            value="accessories"
            className="cursor-pointer rounded-lg px-4 py-2 text-sm font-medium data-[state=active]:bg-emerald-50 data-[state=active]:text-emerald-700 data-[state=active]:shadow-none gap-2"
          >
            <Package className="h-4 w-4" />
            Accessoires
          </TabsTrigger>
          <TabsTrigger
            value="travel-esim"
            className="cursor-pointer rounded-lg px-4 py-2 text-sm font-medium data-[state=active]:bg-emerald-50 data-[state=active]:text-emerald-700 data-[state=active]:shadow-none gap-2"
          >
            <Globe className="h-4 w-4" />
            eSIM internationale
          </TabsTrigger>
        </TabsList>

        <TabsContent value="models" className="space-y-6">
          <DeviceModelsView />
        </TabsContent>

        <TabsContent value="accessories" className="space-y-6">
          <AccessoriesView />
        </TabsContent>

        <TabsContent value="travel-esim" className="space-y-6">
          <TravelEsimTariffsView />
        </TabsContent>
      </Tabs>
    </div>
  );
}
